/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Test_Notification_TitleInputs */

const th_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนใช้งานได้แล้ว`)
};

const en_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are working`)
};

const ja_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知は正常に動作しています`)
};

const zh_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知工作正常`)
};

const es_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones funcionan`)
};

const pt_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As notificações estão funcionando`)
};

const id_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi bekerja`)
};

const fr_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications fonctionnent`)
};

const tl_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gumagana ang mga notipikasyon`)
};

const vi_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo hoạt động`)
};

const ko_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림이 작동합니다`)
};

const de_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen funktionieren`)
};

const ru_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления работают`)
};

const tr_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler çalışıyor`)
};

const it_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le notifiche funzionano`)
};

const pl_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia działają`)
};

const uk_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення працюють`)
};

const hi_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ काम कर रही हैं`)
};

const ar_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات تعمل`)
};

const ms_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan berfungsi`)
};

const bn_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি কাজ করছে`)
};

const zh_tw2_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知運作正常`)
};

const zh_hk2_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知運作正常`)
};

const ur_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات کام کر رہی ہیں`)
};

const fa_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌ها کار می‌کنند`)
};

const sw_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa zinafanya kazi`)
};

const nl_test_notification_title = /** @type {(inputs: Test_Notification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen werken`)
};

/**
* | output |
* | --- |
* | "Notifications are working" |
*
* @param {Test_Notification_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_notification_title = /** @type {((inputs?: Test_Notification_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_Notification_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_notification_title(inputs)
	if (locale === "ja") return ja_test_notification_title(inputs)
	if (locale === "zh") return zh_test_notification_title(inputs)
	if (locale === "es") return es_test_notification_title(inputs)
	if (locale === "pt") return pt_test_notification_title(inputs)
	if (locale === "id") return id_test_notification_title(inputs)
	if (locale === "fr") return fr_test_notification_title(inputs)
	if (locale === "tl") return tl_test_notification_title(inputs)
	if (locale === "vi") return vi_test_notification_title(inputs)
	if (locale === "ko") return ko_test_notification_title(inputs)
	if (locale === "de") return de_test_notification_title(inputs)
	if (locale === "ru") return ru_test_notification_title(inputs)
	if (locale === "tr") return tr_test_notification_title(inputs)
	if (locale === "it") return it_test_notification_title(inputs)
	if (locale === "pl") return pl_test_notification_title(inputs)
	if (locale === "uk") return uk_test_notification_title(inputs)
	if (locale === "hi") return hi_test_notification_title(inputs)
	if (locale === "ar") return ar_test_notification_title(inputs)
	if (locale === "ms") return ms_test_notification_title(inputs)
	if (locale === "bn") return bn_test_notification_title(inputs)
	if (locale === "zh-TW") return zh_tw2_test_notification_title(inputs)
	if (locale === "zh-HK") return zh_hk2_test_notification_title(inputs)
	if (locale === "ur") return ur_test_notification_title(inputs)
	if (locale === "fa") return fa_test_notification_title(inputs)
	if (locale === "sw") return sw_test_notification_title(inputs)
	if (locale === "nl") return nl_test_notification_title(inputs)
	return en_test_notification_title(inputs)
});